import { InMemoryCache } from "apollo-cache-inmemory";

export default (options) => new InMemoryCache(options);
